(function () {
  function perView() {
    if (window.matchMedia('(min-width: 1100px)').matches) return 3;
    if (window.matchMedia('(min-width: 750px)').matches) return 2;
    return 1;
  }

  function init(root) {
    if (!root || root.getAttribute('data-read-result-ready') === 'true') return;
    var track = root.querySelector('[data-read-result-track]');
    if (!track) return;

    var section = root.closest('.read-result') || root;
    var nextBtn = section.querySelector('[data-read-result-next]');
    var prevBtn = section.querySelector('[data-read-result-prev]');
    var mobileSlider = !section.classList.contains('read-result--no-mobile-slider');

    root.setAttribute('data-read-result-ready', 'true');
    var index = 0;
    var startX = 0;
    var dragging = false;

    function items() {
      return track.querySelectorAll('.read-result__item');
    }

    function gap() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    }

    function step() {
      var card = items()[0];
      return card ? card.getBoundingClientRect().width + gap() : 0;
    }

    // How far the track can move before its last card lines up with the
    // right edge of the page content.
    function maxOffset() {
      var list = items();
      var last = list[list.length - 1];
      if (!last) return 0;
      return Math.max(0, last.offsetLeft + last.offsetWidth - root.clientWidth);
    }

    function go(nextIndex) {
      var view = perView();
      var isStatic = items().length <= view || (view === 1 && !mobileSlider);
      section.classList.toggle('is-static', isStatic);

      var size = step();
      var limit = isStatic ? 0 : maxOffset();
      var pages = size && limit > 1 ? Math.ceil((limit - 1) / size) + 1 : 1;
      index = Math.max(0, Math.min(nextIndex, pages - 1));

      var offset = Math.min(index * size, limit);
      track.style.transform = offset > 0 ? 'translateX(' + -offset + 'px)' : '';
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index >= pages - 1;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(index + 1);
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(index - 1);
      });
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      startX = event.clientX;
    });
    track.addEventListener('pointerup', function (event) {
      if (!dragging) return;
      dragging = false;
      var delta = event.clientX - startX;
      if (Math.abs(delta) < 40) return;
      go(delta < 0 ? index + 1 : index - 1);
    });
    track.addEventListener('pointercancel', function () {
      dragging = false;
    });

    window.addEventListener('resize', function () {
      go(index);
    });

    go(0);
  }

  function boot(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-read-result-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
